'use strict';

angular.module('app').factory('config', function (gettextCatalog, selectedLanguage) {
  moment.locale(selectedLanguage);
  return {
    mapIcons: {
      withPrice: {
        iconUrl: '/images/marker.png',
        iconSize: [23, 30],
      },
      yellow: {
        iconUrl: '/images/marker-yellow.png',
        iconSize: [23, 30],
      },
      withPriceSelected: {
        iconUrl: '/images/marker-selected.png',
        iconSize: [23, 30],
      },
      withoutPrice: {
        iconUrl: '/images/circle-pin.png',
        iconSize: [15, 15],
      },
      diveSites: {
        iconUrl: '/images/ds-pin.png',
        iconSize: [36, 36],
      },
      markerViolet: {
        iconUrl: '/images/marker-violet.png',
        iconSize: [23, 30],
      },
    },
    operatorsType: [{
      id: 0,
      title: gettextCatalog.getString('Dive center'),
    }, {
      id: 10,
      title: gettextCatalog.getString('Liveaboard'),
    }, {
      id: 20,
      title: gettextCatalog.getString('Dive resort'),
    }],
    slickResponsive: [{
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
      },
    }, {
      breakpoint: 1024,
      settings: {
        arrows: false,
        slidesToShow: 2,
      },
    }, {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1,
      },
    }],
    guests: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    durations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
    numberOfCourses: ['1', '2', '3', '4', '5', '6', '7', '8'],
    roomsCount: ['1', '2', '3', '4', '5'],
    months: [
      'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'
    ],
    monthsWithCode: [{
      code: 'I',
      title: moment.months(0),
      englishTitle: 'january',
    }, {
      code: 'II',
      title: moment.months(1),
      englishTitle: 'february',
    }, {
      code: 'III',
      title: moment.months(2),
      englishTitle: 'march',
    }, {
      code: 'IV',
      title: moment.months(3),
      englishTitle: 'april',
    }, {
      code: 'V',
      title: moment.months(4),
      englishTitle: 'may',
    }, {
      code: 'VI',
      title: moment.months(5),
      englishTitle: 'june',
    }, {
      code: 'VII',
      title: moment.months(6),
      englishTitle: 'july',
    }, {
      code: 'VIII',
      title: moment.months(7),
      englishTitle: 'august',
    }, {
      code: 'IX',
      title: moment.months(8),
      englishTitle: 'september',
    }, {
      code: 'X',
      title: moment.months(9),
      englishTitle: 'october',
    }, {
      code: 'XI',
      title: moment.months(10),
      englishTitle: 'november',
    }, {
      code: 'XII',
      title: moment.months(11),
      englishTitle: 'december',
    }],
    priceRanges: [{
      from: 0,
      to: 1000,
      id: 1,
    }, {
      from: 1000,
      to: 2000,
      id: 2,
    }, {
      from: 2000,
      to: 3000,
      id: 3,
    }, {
      from: 3000,
      to: null,
      id: 4,
    }],
    roomsAndGuests: [{
      id: 1,
      divers: 1,
      students: 0,
      nonDivers: 0,
      rooms: 1,
    }, {
      id: 2,
      divers: 2,
      students: 0,
      nonDivers: 0,
      rooms: 1,
    }, {
      id: 'auto',
      divers: 1,
      students: 0,
      nonDivers: 1,
      rooms: 1,
    }, {
      id: 'more',
      title: gettextCatalog.getString('More choices...'),
    }],
  };
});
